<template>
  <div>
    <b-table
      :fields="fields"
      :items="items"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      stacked="md"
      show-empty
      responsive
      :tbody-tr-class="verificarTipoLancamento"
      :key="keyAtualizatabela"
    >
      <template #cell(acoes)="item">
        <b-dropdown variant="outline-default">
          <b-dropdown-item @click="$emit('editarDocumentoItem', item.item)">
            {{ $t('GERAL.EDITAR') }}
          </b-dropdown-item>
          <b-dropdown-item @click="excluir(item)">
            {{ $t('GERAL.EXCLUIR') }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  props: {
    items: { type: Array, default: Array },
    keyAtualizatabela: { type: Number, default: 1 },
  },
  data() {
    return {
      fields: [
        {
          key: 'tipoMovimentoDescricao',
          label: this.$t('CONTABIL.TIPO_MOVIMENTO'),
          sortable: true,
        },
        {
          key: 'valor',
          label: this.$t('CONTABIL.VALOR_BRL'),
          sortable: true,
        },
        {
          key: 'contaContabilCompleto',
          label: this.$t('CONTABIL.PLANO_CONTA'),
          sortable: true,
        },
        {
          key: 'descricao',
          label: this.$t('CONTABIL.DESCRICAO_LANCAMENTO'),
          sortable: true,
        },
        {
          key: 'acoes',
          label: this.$t('CONTABIL.ACOES'),
        },
      ],
    };
  },

  methods: {
    verificarTipoLancamento(item) {
      const tipo = item?.tipoMovimentoDescricao?.trim().toLowerCase(); // Normaliza
      if (tipo === 'crédito') return 'linha-credito';
      if (tipo === 'débito') return 'linha-debito';
      return '';
    },
    editar(item) {
      return this.$emit('editarDocumentoItem', item);
    },
    excluir(item) {
      return this.$emit('removerDocumentoItem', item);
    },
  },
};
</script>

<style>
div {
  font-size: 12px;
}
.linha-credito {
  background-color: rgba(67, 230, 67, 0.199); /* Vermelho */
}
.linha-debito {
  background-color: rgba(241, 109, 109, 0.336); /* Vermelho */
}
</style>
